import * as Yup from "yup";
import {LoginPayload} from "interfaces";

export const initialValues: LoginPayload = {
  email: "",
  password: "",
};

export const loginSchema = Yup.object().shape({
  email: Yup.string()
    .email("Debe ser un correo válido")
    .matches(/@[^.]*\./, "Correo electrónico inválido")
    .required("Este campo es requerido"),
  password: Yup.string().required("La contraseña es requerida"),
});
